import { useStaticQuery, graphql } from 'gatsby';

export enum SiteEnvironment {
    PROD = 'prod',
    QA = 'qa',
    UAT = 'uat',
    DEV = 'dev',
}

interface SiteMetadata {
    siteUrl: string;
    umbrella: string;
    vertical: string;
    service: string;
    title: string;
    description: string;
    siteEnvironment: SiteEnvironment;
}

interface SiteMetadataQuery {
    site: {
        siteMetadata: SiteMetadata;
    };
}

export const useSiteMetadata = (): { data: SiteMetadata } => {
    const { site } = useStaticQuery<SiteMetadataQuery>(graphql`
        query {
            site {
                siteMetadata {
                    siteUrl
                    umbrella
                    vertical
                    service
                    title
                    description
                    siteEnvironment
                }
            }
        }
    `);
    return {
        data: { ...site.siteMetadata },
    };
};
